import classNames from 'classnames'
import { SelectHTMLAttributes, forwardRef } from 'react'

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select ({ children, className, ...rest }, ref) {
  return (
    <select
      ref={ref}
      className={classNames('border w-full appearance-none font-medium text-[16px] py-[4.5px] px-[10px] border-gray-400 rounded-[4px] placeholder-gray-600 outline-none leading-6 focus:ring-2 focus:ring-green-900 bg-[right_10px_center] bg-no-repeat', className)}
      style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 10 6\'%3E%3Cpath fill=\'%23161616\' d=\'M5 6 0 1 .7.3 5 4.6 9.3.3l.7.7-5 5Z\' /%3E%3C/svg%3E")',
        backgroundSize: '10px 6px',
      }}
      {...rest}
    >
      {children}
    </select>
  )
})

export default Select
